module.exports = __webpack_public_path__ + "assets/img/qqzhcl-0.c3a590d1.jpg";